import React from 'react';
import { isNull } from 'lodash';
import List from 'components/_shared/dropdown_menu/dropdown_menu_list';
import Option from './Option';

/* eslint react/no-array-index-key:0 */

const Menu = ({ visible, onItemClick, style, options, setRef }) => {
  const menuConfig = {
    dark: true,
    dynamic: true,
    animation: 'slideIn',
  };

  return (
    visible && (
      <List {...menuConfig} style={style} ref={node => setRef(node, 'menu')}>
        {options.map((props, i) => {
          if (isNull(props)) {
            return <hr key={'menu.divider.' + i} />;
          }
          return <Option {...props} key={props.value} onClick={onItemClick} />;
        })}
      </List>
    )
  );
};

export default Menu;
